import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import React from "react";
import { useTranslation } from "react-i18next";

import { RoleCardProps } from "../role_card";
import css from "../role_card.module.scss";

type RoleCardFooterProps = Pick<RoleCardProps, "role" | "counters">;

export const RoleCardFooter = ({ role, counters }: RoleCardFooterProps) => {
  const { t } = useTranslation("marketplace", { keyPrefix: "workOpportunities.roleCard.footer" });
  const { formatDate } = useDateFormatter();
  const interestedCount = counters?.interests || 0;

  return (
    <div className={css.footer}>
      {interestedCount > 0 && (
        <Typography variant="labelRegular" noMargin>
          {t("interestedCount", { count: interestedCount })}
        </Typography>
      )}
      {role.activity.expires_soon && (
        <Typography variant="bodyBold" className={css.dueLabel} noMargin>
          {role.activity.expires_soon && t("due", { date: formatDate(role.activity.post_until) })}
        </Typography>
      )}
    </div>
  );
};
